import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { AppLayout } from '../../../components/layouts';
import PageHeader from '../../../components/dashboard/PageHeader';
import ActivitySection from '../home/ActivitySection';
import UserService from '../../../services/user.service';
import { useRegistration } from '../../../components/layouts/app/RegistrationContext';

export default function ActivityPage() {
    const userService = new UserService();
    const { openAddChildWithWarning } = useRegistration();
    const [searchParams] = useSearchParams();
    const childFilter = searchParams.get('child');

    const [data, setData] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            setLoading(true);
            try {
                const response = await userService.getChildren();
                if (cancelled || !response.status) return;
                let list = response.data || [];
                if (childFilter) {
                    list = list.filter((c: any) => String(c.id) === String(childFilter));
                }
                setData(list);
            } catch {
                /* ignore */
            } finally {
                if (!cancelled) setLoading(false);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [childFilter]);

    return (
        <AppLayout>
            <PageHeader
                title="Activity"
                subtitle="Follow class links, attendance, and ongoing learning activities for your children."
                actionLabel="Add New Child"
                onAction={openAddChildWithWarning}
            />
            <div className="rounded-[22px] border border-[#efe6f1] bg-white p-4 shadow-[0_12px_40px_rgba(136,22,122,0.05)] sm:p-6">
                <ActivitySection data={data} loading={loading} />
            </div>
        </AppLayout>
    );
}
